import theme from './theme.json';
import { ITheme } from './types';
const customTheme: ITheme = theme;
export * from './global.style';
export * from './global.vars';
export { CssA11y } from './styles/a11y';
export { CssBase } from './styles/base';
export { CssDebug } from './styles/debug';
export { CssPrint } from './styles/print';
export { CssReset } from './styles/reset';
export { CssScrollbar } from './styles/scrollbar';
export { CssTypography } from './styles/typography';
export * from './types';
export { customTheme as theme };
export const sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
